import { Expose } from "class-transformer";

export class MarkEmployeeReadyDto {
  @Expose()
  id: string;

  @Expose()
  email: string;

  @Expose()
  roleId?: string;

  @Expose({ name: "accessToOperativeUnitIds" })
  accessToOperativeUnits?: string[];
}
